var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLocationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 54.547,
    viewBox: "0 0 58 54.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-532 -919.453)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(532 955)",
    fill: "none",
    stroke: "#0077da",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 9.5,
    rx: 29,
    ry: 9.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 29,
    cy: 9.5,
    rx: 27.5,
    ry: 8,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.7,2A15.693,15.693,0,0,0,5,17.7C5,29.484,20.7,46.871,20.7,46.871S36.41,29.484,36.41,17.7A15.693,15.693,0,0,0,20.7,2Zm0,21.314A5.609,5.609,0,1,1,26.314,17.7,5.611,5.611,0,0,1,20.7,23.314Z",
    transform: "translate(540.354 918.953)",
    fill: "#f1f2f3",
    stroke: "#0077da",
    strokeWidth: 3
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationIcon);
export default __webpack_public_path__ + "static/media/location-icon.287612da.svg";
export { ForwardRef as ReactComponent };